export default __webpack_public_path__ + "static/media/greeting11.7f9b4c98.png";